import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import { Table, Modal, Form, Button, DatePicker, Row } from "antd";
import * as XLSX from "xlsx";
import { UsePostRequest } from "../../utils/api/ApiRequests";
import {
  getIsAdminLogin,
  getEmployeeId,
  formatAmount,
} from "../../utils/Common";
import { GetAllEmployees } from "../../utils/api/DropdownFiltersApi";


const AddSubmitButton = ({ form, isLoading }) => {
  const [submittable, setSubmittable] = useState(false);

  // Watch all values
  const values = Form.useWatch([], form);
  React.useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
  }, [values]);
  return (
    <Button
      type="primary"
      htmlType="submit"
      disabled={!submittable}
      loading={isLoading}
    >
      Proceed
    </Button>
  );
};

export default function PhicContributionReport() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const isAdminLogin = getIsAdminLogin();
  const employeeId = getEmployeeId();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const employeeOptions = GetAllEmployees();

  const [filterConfig, setFilterConfig] = useState({
    is_updated: false,
    employee_id: isAdminLogin?null:employeeId,
  });

  const tableColumns = [
    {
      title: "Employee",
      dataIndex: "full_name",
      key: "full_name",
    },
    {
      title: "Total Employee Share",
      dataIndex: "total_employee_contribution",
      key: "total_employee_contribution",
      align: "right",
      render: (data) => <div>{formatAmount(data)}</div>,
    },
    {
      title: "Total Employer Share",
      dataIndex: "total_employer_contribution",
      key: "total_employer_contribution",
      align: "right",
      render: (data) => <div>{formatAmount(data)}</div>,
    },
    {
      title: "Total Employee Share",
      dataIndex: "total_amount_contributed",
      key: "total_amount_contributed",
      align: "right",
      render: (data) => <div>{formatAmount(data)}</div>,
    },
  ];

  const handleRowClick = (rowData) => {
    navigate("view", { state: rowData });
  };

  const rowProps = (record) => ({
    onClick: () => handleRowClick(record),
  });

  const onFinish = (formInputs) => {
    const filter = {}
    filter.date_from = formInputs.date_from.format('YYYY-MM-DD');
    filter.date_to = formInputs.date_to.format('YYYY-MM-DD');
    setShowDatePicker(false);
    navigate("print-report", { state: filter });
  };

  function exportToExcel() {
    const excelData = [["Employee Name"]]; // insert header titles first
    // populate excel data
    const employeesWithPhic = tableData.map((data) => data.employee_id);
    // extract employees with no phic contribution
    employeeOptions?.slice(1).forEach((emp) => {
      let tempArray = []
      if (!employeesWithPhic.includes(emp.id)) {
        tempArray.push(emp.name);
        excelData.push(tempArray);
      }
    })
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBlob = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: "application/octet-stream" }
    );
    const excelUrl = URL.createObjectURL(excelBlob);
    const downloadAnchor = document.createElement("a");
    downloadAnchor.href = excelUrl;
    downloadAnchor.download = "No PHIC Employees Report.xlsx";
    downloadAnchor.click();
    setTimeout(() => {
      URL.revokeObjectURL(excelUrl);
    }, 100);
  }

  React.useEffect(() => {
    async function fetchTableData() {
      setIsFetching(true);
      setTableData([]);
      const response = await UsePostRequest(
        "contributions/get_philhealth_contribution",
        filterConfig
      );
      if (response.data) {
        setTableData(response.data);
      }
      setIsFetching(false);
    }

    fetchTableData();
  }, [filterConfig]);

  return (
    <Navbar
      activeNav="phic"
      pageTitle="PhilHealth Contribution"
      noButton
      printButtonTitle="Print Report"
      onClickButton={() => setShowDatePicker(true)}
      isManager
      pageDownloadButtonTitle="Download Excel"
      isDownloadBtn
      onClickDownloadButton={exportToExcel}
    >
      <Table
        className="mt-4"
        rowKey="id"
        onRow={(record) => ({
          ...rowProps(record),
          style: { cursor: "pointer" },
        })}
        columns={tableColumns}
        dataSource={tableData}
        loading={isFetching}
      />

      <Modal
        title="Print PhilHealth Report"
        centereds
        open={showDatePicker}
        onCancel={() => setShowDatePicker(false)}
        footer={false}
      >
        <Form
          form={form}
          className="mt-3 mx-3"
          name="validateOnly"
          layout=""
          onFinish={onFinish}
        >
          <Form.Item
            name="date_from"
            label="Date From"
            rules={[{ required: true }]}
          >
            <DatePicker placeholder="YYYY-MM-DD" />
          </Form.Item>
          <Form.Item
            name="date_to"
            label="Date To"
            rules={[{ required: true }]}
          >
            <DatePicker placeholder="YYYY-MM-DD" />
          </Form.Item>

          <Form.Item>
            <Row className="d-flex justify-content-between">
              <Button
                className="me-2"
                danger
                onClick={() => setShowDatePicker(false)}
              >
                Cancel
              </Button>
              <AddSubmitButton form={form} />
            </Row>
          </Form.Item>
        </Form>
      </Modal>
    </Navbar>
  );
}
